export default __webpack_public_path__ + "static/media/Forgot password-bro.d6189872.png";